import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { isSupportedByLinkingPlatform } from '../../linking-platform';
var linkPatternStart = '\\bhttps?:\\/\\/(?:www\\.)?';
var linkPatternEnd = '[^\\s\\]\\)]*';

// If we want to re-introduce canva support, please use the regex from this
// PR which was made redundant: https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/135407/commits/0fcf626f035396cfcb87153a4d8d4721c844b07a#platform%2Fpackages%2Fai-mate%2Fconversation-assistant%2Fsrc%2Fcommon%2Futils%2Fcontent-transformer%2Fmd-tokenizer%2Fmd-plugin-smartlink%2Findex.ts
// Right now the support is dropped in favour of supporting what the Canva Agent needs.
// It's likely first-class Enhanced Smart links  (e.g `(my canva link "smartCard-embed")[http://some.canva.link]`
// will be how we support this in the future
var linkRegex = {
  youtube: "".concat(linkPatternStart, "youtube\\.com").concat(linkPatternEnd),
  youtubeShortUrl: "".concat(linkPatternStart, "youtu\\.be").concat(linkPatternEnd),
  loomVideo: "".concat(linkPatternStart, "loom\\.com\\/share\\/").concat(linkPatternEnd),
  figmaFile: "".concat(linkPatternStart, "figma\\.com\\/file\\/").concat(linkPatternEnd),
  confluenceWhiteboard: "".concat(linkPatternStart, ".*\\/wiki\\/spaces\\/.*\\/whiteboard\\/").concat(linkPatternEnd),
  googlePresentationAndSpreadsheet: "".concat(linkPatternStart, "docs\\.google\\.com\\/(presentation|spreadsheets)\\/d\\/").concat(linkPatternEnd),
  googleDoc: "".concat(linkPatternStart, "docs\\.google\\.com\\/(document)\\/d\\/edit").concat(linkPatternEnd),
  googleForm: "".concat(linkPatternStart, "docs\\.google\\.com\\/forms\\/d\\/").concat(linkPatternEnd),
  microsoftForm: "".concat(linkPatternStart, "forms\\.office\\.com\\/Pages\\/ResponsePage\\.aspx\\?id\\=").concat(linkPatternEnd),
  analyticsChart: "\\bhttps://[^.]+\\.(atlassian\\.net|jira-dev\\.com)/analytics/[^/]+/chart-".concat(linkPatternEnd)
};
var supportedEmbedProviders = Object.values(linkRegex).join('|');
var embedRegex = new RegExp(supportedEmbedProviders, 'g');
var embedInlineRegex = [// avpRovoSkillsChart
"".concat(linkPatternStart, "avp-rovo-skills\\.[-\\w]+.frontend.public.atl-paas.net/v1/chart[^\\s\\)]+").concat(linkPatternEnd)];
var createSmartLinks = function createSmartLinks(_ref) {
  var regexStorage = _ref.regexStorage;
  return function (state) {
    var _embedMatches;
    var tokens = [];
    var embedTokens = [];
    var embedMatches = [];
    var filteredTokens = [];
    var _iterator = _createForOfIteratorHelper(state.tokens),
      _step;
    try {
      var _loop = function _loop() {
          var _token$content;
          var token = _step.value;
          var processedTokenChildren = [];
          embedMatches = [].concat(_toConsumableArray(embedMatches), _toConsumableArray(new Set((_token$content = token.content) === null || _token$content === void 0 ? void 0 : _token$content.trim().match(embedRegex))));

          // Any block or embed Smart Card links will be in an "inline" token. If
          // the current token is anything other than "inline", or there's no child tokens
          // to process, then we add it to the list of tokens to keep and move forward
          if (token.type !== 'inline' || !token.children) {
            tokens.push(token);
            return 1; // continue
          }
          outputToken = new state.Token('inline', '', 0);
          var tokensToAppend = [outputToken];
          if (token.children) {
            var discardUntilIndex = -1;
            token.children.forEach(function (childToken, i) {
              var _childToken$attrGet, _token$children;
              var discardedToken = i <= discardUntilIndex && ['link_close', 'text'].includes(childToken.type);
              if (discardedToken) {
                return;
              }
              var url = (_childToken$attrGet = childToken.attrGet('href')) !== null && _childToken$attrGet !== void 0 ? _childToken$attrGet : '';
              var isInlineLink = url === ((_token$children = token.children) === null || _token$children === void 0 || (_token$children = _token$children[i + 1]) === null || _token$children === void 0 ? void 0 : _token$children.content);
              if ((childToken === null || childToken === void 0 ? void 0 : childToken.type) === 'link_open' && (isSupportedByLinkingPlatform(url, regexStorage) || isInlineLink)) {
                // Discard the next two tokens. We're now processing the opening node for a URL
                // that will result in a new node that replaces it, therefore the subsequent link content and
                // closing node are no longer needed
                discardUntilIndex = i + 2;
                if (token.level <= 1 && embedInlineRegex.some(function (r) {
                  return url.match(r);
                })) {
                  outputToken.children = processedTokenChildren;
                  tokensToAppend.push(new state.Token('paragraph_close', '', 0));
                  processedTokenChildren = [];
                  var embedToken = new state.Token('embedCard', '', 0);
                  embedToken.content = '';
                  embedToken.block = true;
                  embedToken.attrSet('url', url);
                  embedToken.attrSet('layout', 'center');
                  tokensToAppend.push(embedToken);
                  tokensToAppend.push(new state.Token('paragraph_open', '', 0));
                  outputToken = new state.Token('inline', '', 0);
                  tokensToAppend.push(outputToken);
                  return;
                }
                var cardToken = new state.Token('inlineCard', '', 0);
                cardToken.content = '';
                cardToken.block = false;
                cardToken.level = childToken.level;
                cardToken.attrSet('url', url);
                processedTokenChildren.push(cardToken);
                return;
              }
              processedTokenChildren.push(childToken);
            });
          }
          outputToken.children = processedTokenChildren;
          var blockTokensWithContent = tokensToAppend.filter(function (t) {
            var _t$children;
            return t.type !== 'inline' || ((_t$children = t.children) === null || _t$children === void 0 ? void 0 : _t$children.length);
          });
          tokens.push.apply(tokens, _toConsumableArray(blockTokensWithContent));
        },
        outputToken;
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        if (_loop()) continue;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    for (var i = 0; i < tokens.length; i++) {
      if (i < tokens.length - 1 && tokens[i].type === 'paragraph_open' && tokens[i + 1].type === 'paragraph_close') {
        i = i + 1;
      } else {
        filteredTokens.push(tokens[i]);
      }
    }
    if ((_embedMatches = embedMatches) !== null && _embedMatches !== void 0 && _embedMatches.length) {
      _toConsumableArray(new Set(embedMatches)).forEach(function (match) {
        var embedToken = new state.Token('embedCard', '', 0);
        embedToken.content = '';
        embedToken.block = true;
        embedToken.attrSet('url', match);
        embedToken.attrSet('layout', 'center');
        embedTokens.push(embedToken);
      });
    }
    state.tokens = [].concat(filteredTokens, embedTokens);
    return;
  };
};
export var createSmartLinksPlugin = function createSmartLinksPlugin(params) {
  return function (md) {
    return md.core.ruler.push('inlineCard', createSmartLinks(params));
  };
};